import SurveyForm from "@/components/survey/index.vue";
import VueClickAway from "vue3-click-away";
import { createApp } from "vue/dist/vue.esm-bundler";
import { createPinia } from "pinia";
import initializeSentry from "@/utils/sentry";
import mitt from "mitt";
const emitter = mitt();

const SurveyFormShow = createApp({
  components: {
    "survey-form-view": SurveyForm,
  },
  mounted() {
    // Hide loading skeleton once Vue app is mounted
    const skeleton = document.getElementById("survey-skeleton");
    if (skeleton) {
      skeleton.style.display = "none";
    }
  },
});

const pinia = createPinia();

initializeSentry(SurveyFormShow);
SurveyFormShow.config.globalProperties.emitter = emitter;
SurveyFormShow.use(VueClickAway);
SurveyFormShow.use(pinia);
SurveyFormShow.mount("#survey-form-index");
